import React from 'react';

import Autocomplete from "@mui/material/Autocomplete";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from "@mui/material/TextField";

import villes_list from "../res/InputVilleList";

function WidgetInputVilleList({ state, setState, id, text, readOnly = false, value = [] }) {
  

  React.useEffect(() => {
    setState({
      id: id,
      value: value,
      error: false,
      errorMessage: null,
    });
  }, []);

  const handleChange = (e, v) => {
    setState((s) => ({ ...s, value: v, error: false }));
  };


  return (
    <>
      {state !== null &&
        <FormControl error={state.error} className='w-full'>
          <Autocomplete
            className='shadow-md shadow-gray-300'
            id={state.id}
            options={villes_list}
            multiple
            getOptionLabel={(option) => option}
            readOnly={readOnly}

            filterOptions={(options, state) => {
              const input = state.inputValue.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace("-", " ");
              const filtered_options = options.filter((item) =>
                String(item).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace("-", " ").includes(input)
              );

              // const eq_options = options.filter((item) =>
              //   String(item).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace("-", " ") === input
              // );

              // if (eq_options.length >= 1) {
              //   return eq_options.sort();
              // }

              if (filtered_options.length <= 1000) {
                return filtered_options.sort();
              }

              return [];
            }}

            value={state.value}
            onChange={handleChange}

            renderInput={(v) => (<TextField  {...v} error={state.error} variant='outlined' label={text} />)}
          />
          <FormHelperText>
            (Appuiez sur "Entrer" pour ajouter)
            <br />
            {state.error && state.errorMessage}
          </FormHelperText>
        </FormControl>
      }
    </>
  );
}

export default React.memo(WidgetInputVilleList);